<div class="card mb-0" [ngClass]="{ isCorrect: isCorrect, isWrong: !isCorrect }">
  <div class="card-body ">
    <div class="d-flex align-items-center">
      <img [src]="imageUrl" height="220" class="mr-3" alt="" />
      <div class="description-text">
        <h3>{{ correctStatus }}</h3>
        <p *ngIf="!isCorrect" class="mb-3" [innerHTML]="'The correct answer is ' + correctAnswer"></p>
        <ng-container *ngIf="answerDescription">
          <p>Answer Description:</p>
          <p class="mb-0" [innerHTML]="answerDescription"></p>
          <img *ngFor="let image of currentQuestion?.descriptionMediaDTOS" [src]="image.media" [class]="
              currentQuestion?.descriptionMediaDTOS?.length ? 'mb-0' : 'mb-1'
            " alt="Description Img" />
        </ng-container>
      </div>
    </div>
    <div class="d-flex align-items-baseline" [ngClass]="{'justify-content-end': isFirstQuestion, 'justify-content-between': !isFirstQuestion, 'd-none': isFirstQuestion}">
      <button class="btn btn-outline-primary mt-2" [ngClass]="{ 'd-none': isFirstQuestion }" (click)="togglePrevQuestion()" style="background-color: transparent ;">
        Previous
      </button>
      <button class="btn btn-primary" [ngClass]="{ 'd-none': isLastQuesion }" (click)="toggleNextQuestion()">
        Next
      </button>
    </div>
  </div>
</div>